import React, { FC, useMemo } from "react";

import { Dropdown, DropdownButton, DropdownMenuRaw } from "composants/DropDown/Dropdown";
import { Fa } from "composants/Icon";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Trans } from "react-i18next";
import { ReducerState } from "reducers";
import { AppGalaxyInfo } from "types/Galaxy";
import { Link } from "react-router-dom";

import "./LeGrosMenu.css";
import { findMap } from "utils/entities.utils";
import { IconName } from "@fortawesome/pro-solid-svg-icons";

const getSelectorGalaxiesInfos = createSelector(
  (s: ReducerState) => s.app.galaxies,
  (s: ReducerState) => s.app.mostUsed,
  (s: ReducerState) => s.app.favoris,
  (galaxies, mostUsed, favoris) => ({ galaxies, mostUsed, favoris })
);

const LeGrosMenuInternal: FC = props => {
  const galaxiesInfos = useSelector(getSelectorGalaxiesInfos);

  const home = useMemo(() => {
    return findMap(galaxiesInfos.galaxies, el => el.type === "HOME");
  }, [galaxiesInfos.galaxies]);

  const univers = useMemo(() => {
    let appInfosUnivers: AppGalaxyInfo[] = [];
    const keys = Object.keys(galaxiesInfos.galaxies);

    for (let key of keys) {
      if (galaxiesInfos.galaxies[key].type === "UNIVERS") {
        appInfosUnivers.push(galaxiesInfos.galaxies[key]);
      }
    }
    return appInfosUnivers;
  }, [galaxiesInfos.galaxies]);

  return (
    <Dropdown autoclose>
      <DropdownButton
        render={param => {
          return (
            <button
              ref={param.buttonRef}
              className="system-topbar-icon-btn"
              onClick={() => (param.isActive ? param.onClose() : param.onOpen())}
              title="menu"
            >
              <span className="icon">
                <Fa icon="bars" />
              </span>
            </button>
          );
        }}
      />
      <DropdownMenuRaw
        backgroundClass="gros-menu-background"
        style={{ zIndex: 50 }}
        render={({ onClose }) => {
          return (
            <div className="box" style={{ width: "48rem", padding: 0, overflow: "hidden" }}>
              <div className="gm-panel">
                <section className="p-5">
                  <p className="system-eyebrow" style={{ marginBottom: "0.5rem" }}>
                    <Trans i18nKey="commun_univers">Univers</Trans>
                  </p>
                  {univers.length > 0 ? (
                    <div className="gm-univers">
                      {home && (
                        <Link
                          className="system-rail-item"
                          to={`/page/${home.code}`}
                          onClick={onClose}
                        >
                          <span className="icon is-small">
                            <Fa icon={["fal", "home"]} fixedWidth />
                          </span>
                          <span>{home.label}</span>
                        </Link>
                      )}
                      {univers.map(univ => (
                        <Link
                          key={univ.code}
                          className="system-rail-item"
                          to={`/page/${univ.code}`}
                          onClick={onClose}
                        >
                          <span className="icon is-small">
                            <Fa
                              icon={[
                                "fal",
                                (univ.icon
                                  ? univ.icon.startsWith("fa-")
                                    ? univ.icon.replace(/fa-/g, "")
                                    : univ.icon
                                  : "stars") as IconName
                              ]}
                              fixedWidth
                            />
                          </span>
                          <span>{univ.label}</span>
                        </Link>
                      ))}
                    </div>
                  ) : (
                    <p className="subtitle is-6">
                      <Trans i18nKey="commun_aucun_univers">Aucun univers de paramétré</Trans>
                    </p>
                  )}
                </section>

                <div className="gm-sidebar">
                  <section className="p-5">
                    <p className="system-eyebrow" style={{ marginBottom: "0.5rem" }}>
                      <Trans i18nKey="commun_suggestion">Suggestion</Trans>
                    </p>
                    <div className="gm-chips">
                      {galaxiesInfos.mostUsed
                        .filter(
                          galaxy => !galaxiesInfos.favoris.some(fav => fav.code === galaxy.code)
                        )
                        .map(galaxy => (
                          <Link
                            key={galaxy.code}
                            className="gm-chip"
                            to={`/page/${galaxy.code}`}
                            onClick={onClose}
                          >
                            {galaxy.label}
                          </Link>
                        ))}
                    </div>
                  </section>
                </div>
              </div>
            </div>
          );
        }}
      />
    </Dropdown>
  );
};

export const LeGrosMenu = LeGrosMenuInternal;
